export default "__VITE_ASSET__kRUuWEXr__"